import { useState, useEffect } from "react";
import { loadShifAssignmentStatus } from "../services/shiftService";


const useAssignmentStatus = (editShiftAssignmentID) => {
    const [assignmentStatus, setAssignmentStatus] = useState([]);
    const [selectedassignmentStatus, setSelectedAssignmentStatus] = useState(null);
    const [selectedassignmentStatusID, setSelectedAssignmentStatusID] = useState(null);
    const [isLocationDataLoaded, setIsLocationDataLoaded] = useState(false);

    // Fetch department data
    const fetchAssignmentStatus = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadShifAssignmentStatus(para);
            if (data && data.length > 0) {
                setAssignmentStatus(data);
                const initialDepartment = data.find((dept) => dept.id === selectedID);
                // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
                if (initialDepartment?.length > 0 ) {
                    setSelectedAssignmentStatus(initialDepartment);
                    setSelectedAssignmentStatusID(initialDepartment.id);
                    setIsLocationDataLoaded(true);
                }

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isLocationDataLoaded && editShiftAssignmentID === 0) {
            fetchAssignmentStatus();
        }
    }, [isLocationDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID
    const loadAssignmentStatusByID = async (selectedID) => {
        await fetchAssignmentStatus(selectedID);
    };

    return {
        assignmentStatus, selectedassignmentStatus, selectedassignmentStatusID, setSelectedAssignmentStatus, setSelectedAssignmentStatusID, loadAssignmentStatusByID,
    };
};

export default useAssignmentStatus;